export const DEFAULT_ORGANIZATION_NAME = 'default organization';
